import React from 'react';
import { connect } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import TapApiUrls from '../../../services/TapApiUrls';
import Ax from '../../../components/hoc/Ax';
import { Modal } from 'bootstrap';
import Loader from '../../../components/ui/Loader/Loader';
import moment from "moment";
import AppBaseComponent from '../../../components/AppBaseComponent';
import InterchangeableItemModal from '../InterchangeableItemModal';
import Status from '../../../components/ui/Status';
import ItemWhConfig from '../configuration/ItemWhConfig';
import { INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import ReusableItemTabs from '../ReusableItemsTabs';
import uuid from "react-uuid";

class ItemDetailsModal extends AppBaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            itemData: null,
            showLinkedQty: false,
            linkedQty: 0,
            tabName: "details",
            isInventory: false
        }
        this.itemModalId = uuid();
    }

    componentDidMount() {
        this.viewItemModal = new Modal(document.getElementById(this.itemModalId), { keyboard: false, backdrop: false });
        
        // Only set itemData if passed from parent, don't fetch
        if (this.props && this.props.itemData) {
            this.setState({ itemData: this.props.itemData });
        }
    }

    // REMOVED all API fetching methods - getItemDetails, getInterchangeableListing, 
    // getInventoryListing, additionalAttHandle - let the tabs handle their own data

    modalInit = (item, linkedQty = 0, showLinkedQty = false, showInventory) => {
        this.viewItemModal.show();
        if (item) {
            this.setState({ 
                itemData: item, 
                linkedQty: linkedQty, 
                showLinkedQty: showLinkedQty, 
                isInventory: showInventory, 
                tabName: showInventory ? "inventory" : "details"
            });
            // NO API CALLS HERE - just set the item data
        }
    }

    itemModalClose = () => {
        this.props.closeEvent();
    }
    
    changeTab = (name) => {
        this.setState({ tabName: name });
    }

    getAllowedTabs = () => {
        const { category } = this.state.itemData || {};
        const baseTabs = ['details', 'interchangeable', 'inventory', 'configuration', 'additional_attribute'];
        
        if (category === 'services') {
            return ['details', 'interchangeable', 'additional_attribute'];
        }
        
        return baseTabs;
    }

    //*********************************ITEM ADD JSX*********************** */
    viewItemModalJsx = () => {
        return (
            <div className="modal fade" id={this.itemModalId} tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="viewItemModalLabel">
                                Item : {this.state.itemData?.name} ({this.state.itemData?.item_code})
                            </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {this.state.showLinkedQty && (
                                <div className='p-1 bg-light border-bottom'>
                                    <table className='table table-sm mb-0 table-borderless text-sm'>
                                        <tbody>
                                            <tr>
                                                <td style={{ width: "26%" }}>Linked Qty</td>
                                                <th>{this.state.linkedQty || "0"}</th>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            )}
                            
                            {/* Use ReusableItemTabs here - NO PROPS FOR API METHODS */}
                            {this.state.itemData && (
                                <ReusableItemTabs
                                    useRouting={false}
                                    activeTab={this.state.tabName}
                                    onChangeTab={this.changeTab}
                                    itemId={this.state.itemData.id}
                                     category={this.state.itemData ? this.state.itemData.category : "goods"}
                                    allowedTabs={this.getAllowedTabs()}
                                    extraProps={{
                                        access_token: this.props.access_token,
                                        isc_configuration: this.props.isc_configuration,
                                        hideHelmet: true // Add this to hide Helmet in modal
                                    }}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return <Ax>{this.viewItemModalJsx()}</Ax>;
    }
}

const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token,
        isc_configuration: state.app && state.app.isc_configuration ? state.app.isc_configuration : null,
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(ItemDetailsModal);